import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import useIsFieldRequired from '../../../utility/useIsFieldRequired';

const RMSDatePicker = ({
  name,
  label,
  disabled = false,
  format = 'dd/MM/yyyy',
  minDate,
  maxDate,
  size = 'small',
  ...rest
}) => {
  const { control, trigger } = useFormContext();

  const isRequired = useIsFieldRequired(name);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <KeyboardDatePicker
            {...rest}
            autoOk
            fullWidth
            autoComplete="off"
            variant="inline"
            inputVariant="outlined"
            size={size}
            format={format}
            label={label}
            disabled={disabled}
            value={field.value || null}
            minDate={minDate}
            maxDate={maxDate}
            onChange={(date) => {
              field.onChange(date);
              trigger(name);
            }}
            error={!!error}
            helperText={error?.message}
            onBlur={field.onBlur}
            required={isRequired}
          />
        )}
      />
    </MuiPickersUtilsProvider>
  );
};

export default RMSDatePicker;
